const initialState = {
    list: null,
};

const surveyReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'SURVEY_SUCCESS':
        return {
          ...state,
          list: action.payload,
        };
      case 'SURVEY_FAILURE':
        return state;
      default:
        return state;
    }
  };
  
  export default surveyReducer;
